exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\ndiv[col-id='checked'] {\n  pointer-events: all !important;\n}\n.configurar-alertas .ag-body-viewport .ag-pinned-left-cols-container,\n.configurar-alertas .ag-header .ag-pinned-left-header {\n  display: none;\n}\n.BtnIcon {\n  color: #526da5 !important;\n}\n.configurar-alertas .estilo-grilla {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n", ""]);

// exports
